module.exports = __webpack_public_path__ + "static/media/ask.b6f5274c.png";